import type { EventUser, User } from '@/store/modules/event/types';

import { getUserProfileImageUrl, getPublicThumbnailImage, getMediumSizedImage } from '@/services/user_image.service';

export function makeUsers(users: EventUser[]): User[] {
  return users.map(makeUser);
}

export function makeUser(eventUser: EventUser): User {
  const { user, tags, event, track, event_role, ticket_codes, view_as_attendee, ...eUser } = eventUser || { user: {} };

  const oneUser = {
    event,
    ...user,
    eventUser: {
      ...eUser,
      track,
      event_role,
      ticket_codes,
      view_as_attendee: !!view_as_attendee
    } as EventUser,
    track,
    event_role,
    image: getUserProfileImageUrl(user),
    name: (user?.first_name || '').concat(' ').concat(user?.last_name || ''),
    thumbnail: getPublicThumbnailImage(user),
    mediumimage: getMediumSizedImage(user),
    ...(user?.images || {}),
    tags: tags || [],
    ticket_codes
  };
  return oneUser;
}
